import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-router-handler-component',
  templateUrl: './router-handler-component.component.html',
  styleUrls: ['./router-handler-component.component.css']
})
export class RouterHandlerComponent implements OnInit {
  currentUrl: string;
  constructor(private router:Router) {
    console.log('enterl')
    let url: string = router.url;
    let urlArray = [];
    urlArray = url.split("/");
    console.log(urlArray)
    this.currentUrl = urlArray[1];
    console.log(this.currentUrl)
    this.currentUrl=this.currentUrl.toLowerCase()
    if(
      this.currentUrl=='remit-and-eligibility'||
      this.currentUrl=='application-process'||
      this.currentUrl=='roles-on-application'||
      this.currentUrl=='costing-policies'||
      this.currentUrl=='costing-policies-grants'||
      this.currentUrl=='award-conditions'||
      this.currentUrl=='grantsmanship-guidance-notes'||
      this.currentUrl=='award-policies'||
      this.currentUrl=='reimbursement'||
      this.currentUrl=='subject-classification'||
      this.currentUrl=='faq-fellowship'||
      this.currentUrl=='faq-grants'
    ){
      this.router.navigate(['/applicants',this.currentUrl])
    }
    else if(
      this.currentUrl=='about-ia'||
      this.currentUrl=='funded-areas'||
      this.currentUrl=='ceo-message'||
      this.currentUrl=='ia-staff-and-committee-members'||
      this.currentUrl=='annual-reports'||
      this.currentUrl=='brand-usage-guidelines'
    ){
      this.router.navigate(['/about-us',this.currentUrl])
    }
    else if(this.currentUrl=='fellowships'){
      let tempUrl:string
      tempUrl=urlArray[2]
      if(tempUrl=='early-career-fellowships'||
      tempUrl=='intermediate-fellowships'||
      tempUrl=='senior-fellowships'){
        this.router.navigate(['/fellowshiptype','basic-biomedical-research-fellowships'])
      }else{
        this.router.navigate(['/fellowshiptype','clinical-and-public-health-research-fellowships'])
      }
    }
    else if(this.currentUrl=='news-detailview'){
      this.router.navigate(['/news',urlArray[2]])
    }
    else{
      this.router.navigateByUrl('/')
    }
   }
  ngOnInit() {
  }
}
